import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import SearchBar from '../../../components/SearchBar';
import Pagination from '../../../components/Pagination';
import Button from '../../../components/Button';
import { Table } from '../../../components/Table';
import styles from '../css/DOHGuideline.module.css';

const DOHGuideline = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const pageSize = 10;

  // Seed data to match screenshot; duplicate to show pagination controls
  const baseRows = useMemo(
    () => [
      { name: 'Family Planning' },
      { name: 'Musculoskeletal Condition' },
      { name: 'Preventive Infection and Related Condition' },
    ],
    []
  );

  const rows = useMemo(() => {
    // Create multiple pages for demo pagination (6 pages like screenshot)
    const copies = new Array(2).fill(null).flatMap(() => baseRows);
    return copies.map((r, idx) => ({ id: idx + 1, ...r }));
  }, [baseRows]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((r) => r.name.toLowerCase().includes(q));
  }, [rows, search]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const currentPage = Math.min(page, totalPages);
  const paginated = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filtered.slice(start, start + pageSize);
  }, [filtered, currentPage]);

  const handleView = (row) => {
    // Navigate to Family Planning view for any selection and pass the heading
    navigate('/customer/clinic/doh-guideline/family-planning', {
      state: { title: row.name },
    });
  };

  const columns = [
    { header: 'DoH Name', accessor: 'name' },
    {
      header: 'Action',
      accessor: 'action',
      render: (value, row) => (
        <Button variant="primary" className={styles.viewBtn} onClick={() => handleView(row)}>
          View
        </Button>
      ),
    },
  ];

  return (
    <div className={styles.pageWrapper}>
      <Navbar />
      <main className={styles.container}>
        <div className={styles.controlsRow}>
          <h1 className={styles.title}>DoH Guideline</h1>
          <div className={styles.searchWrap}>
            <SearchBar value={search} onChange={setSearch} placeholder="Search" />
          </div>
        </div>

        <div className={styles.tableContainer}>
          <Table columns={columns} data={paginated} />
        </div>

        <div className={styles.paginationContainer}>
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setPage} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DOHGuideline;

